import { render, staticRenderFns } from "./VDropdownDivider.vue?vue&type=template&id=28cabd15&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cabd15')) {
      api.createRecord('28cabd15', component.options)
    } else {
      api.reload('28cabd15', component.options)
    }
    module.hot.accept("./VDropdownDivider.vue?vue&type=template&id=28cabd15&", function () {
      api.rerender('28cabd15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/dropdown/VDropdownDivider.vue"
export default component.exports